import React, { useState } from "react";
import { BigHeadline } from "../../../../components/TextParts";
import { Box, Tabs, Tab } from "@mui/material";
import SearchFromRecruitment from "../organisms/SearchFromRecruitment";

function TabPanel({ children, value, index, ...other }) {
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`full-width-tabpanel-${index}`}
      aria-labelledby={`full-width-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ py: 2 }}>{children}</Box>}
    </div>
  );
}

function a11yProps(index) {
  return {
    id: `full-width-tab-${index}`,
    "aria-controls": `full-width-tabpanel-${index}`,
  };
}

export default function PersonnelListTemplate() {
  const [tabValue, setTabValue] = useState(0);

  const handleChange = (event, newValue) => {
    setTabValue(newValue);
  };

  return (
    <Box>
      <BigHeadline text="技術提供主(要員)一覧" />
      <Tabs
        value={tabValue}
        onChange={handleChange}
        indicatorColor="primary"
        textColor="primary"
        aria-label="要員一覧タブ"
      >
        <Tab label="募集から検索" {...a11yProps(0)} />
      </Tabs>
      <TabPanel value={tabValue} index={0}>
        <SearchFromRecruitment />
      </TabPanel>
    </Box>
  );
}